import React, { useState } from 'react';
import Rating from '../Rating';
import { useTranslation } from 'react-i18next';

export default function Testimonial() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(2);
  const handleTabClick = tabNumber => {
    setActiveTab(tabNumber);
  };
  const people = t('home.testimonials.people', { returnObjects: true });
  const messages = t('home.testimonials.messages', { returnObjects: true });
  return (
    <div className="cs_tabs cs_style1">
      <ul className="cs_tab_links">
        <li className={activeTab === 1 ? 'active' : ''}>
          <div className="cs_tab_link_in" onClick={() => handleTabClick(1)}>
            <div className="cs_testimonial_1_avatar">
              <img src="/images/home_1/testi1.png" alt="Avatar" />
              <div className="cs_testimonial_1_avatar_right">
                <h3 className="cs_fs_24 cs_semibold mb-0">{people?.[0]?.name || 'Fanta'}</h3>
                <p className="cs_heading_color mb-0">{people?.[0]?.meta || '37 ans, France'}</p>
              </div>
            </div>
          </div>
        </li>
        <li className={activeTab === 2 ? 'active' : ''}>
          <div className="cs_tab_link_in" onClick={() => handleTabClick(2)}>
            <div className="cs_testimonial_1_avatar">
              <img src="/images/home_1/testi2.png" alt="Avatar" />
              <div className="cs_testimonial_1_avatar_right">
                <h3 className="cs_fs_24 cs_semibold mb-0">{people?.[1]?.name || 'Aïdara'}</h3>
                <p className="cs_heading_color mb-0">{people?.[1]?.meta || '45 ans, Canada'}</p>
              </div>
            </div>
          </div>
        </li>
        <li className={activeTab === 3 ? 'active' : ''}>
          <div className="cs_tab_link_in" onClick={() => handleTabClick(3)}>
            <div className="cs_testimonial_1_avatar">
              <img src="/images/home_1/testi3.png" alt="Avatar" />
              <div className="cs_testimonial_1_avatar_right">
                <h3 className="cs_fs_24 cs_semibold mb-0">{people?.[2]?.name || 'Alioune'}</h3>
                <p className="cs_heading_color mb-0">{people?.[2]?.meta || '50 ans, Angleterre'}</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div className="cs_tab_body">
        {activeTab === 1 && (
          <div className="cs_testimonial cs_style_1">
            <img src="/images/icons/quote.svg" alt="Icon" />
            <p>{messages?.[0] || 'Je suis sereine pour les soins de santé de ma mère à Dakar, prise en charge et remboursement rapides. Merci.'}</p>
            <Rating ratingNumber={5} />
          </div>
        )}
        {activeTab === 2 && (
          <div className="cs_testimonial cs_style_1">
            <img src="/images/icons/quote.svg" alt="Icon" />
            <p>{messages?.[1] || 'Vos conseillers sont efficaces et réactifs. J’ai pu choisir rapidement l’offre adaptée à mes parents et enfants à Thiès'}</p>
            <Rating ratingNumber={4.5} />
          </div>
        )}
        {activeTab === 3 && (
          <div className="cs_testimonial cs_style_1">
            <img src="/images/icons/quote.svg" alt="Icon" />
            <p>{messages?.[2] || 'Avec TransVie Diaspora, j’ai l’esprit tranquille. Je peux vérifier facilement si ma famille a bénéficié de tous les soins nécessaires pour leur santé.'}</p>
            <Rating ratingNumber={4.5} />
          </div>
        )}
      </div>
    </div>
  );
}
